var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "compose_1_",
    "data-name": "compose (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.051,
    height: 15.341,
    viewBox: "0 0 16.051 15.341",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38989",
    "data-name": "Group 38989",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38988",
    "data-name": "Group 38988"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31234",
    "data-name": "Path 31234",
    d: "M7.262,13.492A6.295,6.295,0,1,1,8.94,1.127L9.18.262A7.194,7.194,0,1,0,14.2,9.112l.011-.042-.868-.233A6.3,6.3,0,0,1,7.262,13.492Z",
    transform: "translate(-0.068 0.949)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pen_3_",
    "data-name": "pen (3)",
    transform: "matrix(0.999, -0.035, 0.035, 0.999, 5.054, 0.581)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31237",
    "data-name": "Path 31237",
    d: "M.011,2.65a.284.284,0,0,0,.273.362A.265.265,0,0,0,.362,3l2.65-.756L.767,0Zm0,0",
    transform: "translate(0.009 6.685)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31238",
    "data-name": "Path 31238",
    d: "M.293,3.039a.292.292,0,0,1-.281-.374L.774,0,3.042,2.267l-2.669.76a.285.285,0,0,1-.08.011Zm.489-3L.029,2.669a.274.274,0,0,0,.263.349.264.264,0,0,0,.076-.011L3,2.254Zm0,0",
    transform: "translate(0 6.668)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31239",
    "data-name": "Path 31239",
    d: "M3.014,1.454,1.81.25A.856.856,0,0,0,.6.248l-.6.6,2.41,2.41.6-.6a.856.856,0,0,0,0-1.2Zm0,0",
    transform: "translate(6.433 0.009)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31240",
    "data-name": "Path 31240",
    d: "M2.423,3.284,0,.861.609.252a.86.86,0,0,1,1.217,0l1.2,1.2a.861.861,0,0,1,0,1.217ZM.027.861l2.4,2.4.6-.6a.842.842,0,0,0,0-1.191L1.814.265a.844.844,0,0,0-1.192,0Zm0,0",
    transform: "translate(6.422)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31241",
    "data-name": "Path 31241",
    d: "M0,4.937,4.937,0l2.41,2.41L2.41,7.348Zm0,0",
    transform: "translate(1.096 1.262)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31242",
    "data-name": "Path 31242",
    d: "M2.425,7.375,0,4.95,4.952,0,7.375,2.423ZM.028,4.95l2.4,2.4L7.348,2.423l-2.4-2.4Zm0,0",
    transform: "translate(1.081 1.249)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_31243",
    "data-name": "Path 31243",
    d: "M5.573,2.64,3.606-.334l7.127-1.008.279,1.19L9.7,1.985Z",
    transform: "translate(-1.056 1.342)",
    fill: "#39be9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31244",
    "data-name": "Path 31244",
    d: "M16.792,11.244,19,12.956l1.967-5.33L19,5.817,17.2,7.4Z",
    transform: "translate(-4.918 -0.755)",
    fill: "#39be9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31245",
    "data-name": "Path 31245",
    d: "M.053.022A6.376,6.376,0,0,1,0,.839L.892.954A7.356,7.356,0,0,0,.952.022V0Z",
    transform: "translate(11.807 12.282) rotate(43)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31246",
    "data-name": "Path 31246",
    d: "M.168,1.06,1.06.939A7.224,7.224,0,0,0,.867,0L0,.239A6.208,6.208,0,0,1,.168,1.06Z",
    transform: "translate(12.974 10.777) rotate(43)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31247",
    "data-name": "Path 31247",
    d: "M13.458,16.192l1.21,1.741,3.614-2.315V13.363L16.1,12.584Z",
    transform: "translate(-3.941 -2.736)",
    fill: "#39be9d"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompose);
export default __webpack_public_path__ + "static/media/compose.9297affb8ef974cf14f72e89e78fb9a9.svg";
export { ForwardRef as ReactComponent };